<template>
  <div class="toolbar">

    <v-toolbar flat
               color="blue-grey darken-4"
               style="border-radius: 0"
    >
      <v-toolbar-title>
        <v-btn icon @click.stop="toggleDrawer">
          <v-icon color="white">mdi-view-list</v-icon>
        </v-btn>
        <span class="font-weight-light">{{ title }}</span>
      </v-toolbar-title>

      <v-spacer> </v-spacer>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <w-login-widget style="margin-top:15px;" :theme="'light'"> </w-login-widget>
      </template>
    </v-toolbar>


  </div>

</template>
<script>

import {
  mapMutations
} from 'vuex'

export default {
  data: () => ({
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      'You\'re now a friend with Andrew',
      'Another Notification',
      'Another One'
    ],
    title: null,
    responsive: true,
    responsiveInput: true
  }),

  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  methods: {
    toggleDrawer(){
      this.$emit('toggle-drawer')
    },
  }
}
</script>

<style scoped lang="scss">
  #core-toolbar a {
    text-decoration: none;
  }

  .v-toolbar__content {
    margin-left: 0px !important;
  }
</style>
